import { ValueUpdater } from '../../valueUpdater';
import { Defect } from './defect';
import { FlatRateUnit } from './flatRateUnit';
import { Package } from './package';
import { Part } from './part';
export class Job {
    static constructFromPlainObject(sourceJob) {
        const defects = sourceJob.defects
            ? sourceJob.defects.map((d) => Defect.constructFromPlainObject(d))
            : sourceJob.defects;
        const flatRateUnits = sourceJob.flatRateUnits
            ? sourceJob.flatRateUnits.map((f) => FlatRateUnit.constructFromPlainObject(f))
            : sourceJob.flatRateUnits;
        const parts = sourceJob.parts ? sourceJob.parts.map((p) => Part.constructFromPlainObject(p)) : sourceJob.parts;
        const packages = sourceJob.packages
            ? sourceJob.packages.map((pck) => Package.constructFromPlainObject(pck))
            : sourceJob.packages;
        const job = new Job(sourceJob.externalId, sourceJob.title);
        job.isActive = ValueUpdater.updateNonNullableBoolean(job.isActive, sourceJob.isActive);
        job.comment = ValueUpdater.updateNonNullableString(job.comment, sourceJob.comment);
        job.customerStatement = ValueUpdater.updateNonNullableString(job.customerStatement, sourceJob.customerStatement);
        job.defects = ValueUpdater.updateNonNullableField(job.defects, defects);
        job.flatRateUnits = ValueUpdater.updateNonNullableField(job.flatRateUnits, flatRateUnits);
        job.parts = ValueUpdater.updateNonNullableField(job.parts, parts);
        job.packages = ValueUpdater.updateNonNullableField(job.packages, packages);
        job.demandCategory = ValueUpdater.updateNonNullableString(job.demandCategory, sourceJob.demandCategory);
        job.demandId = ValueUpdater.updateNonNullableString(job.demandId, sourceJob.demandId);
        job.positionNumber = ValueUpdater.updateNullableNumber(job.positionNumber, sourceJob.positionNumber);
        job.lastModifiedVersion = ValueUpdater.updateNonNullableStrictlyPositiveInteger(job.lastModifiedVersion, sourceJob.lastModifiedVersion);
        job.isSelected = ValueUpdater.updateNonNullableBoolean(job.isSelected, sourceJob.isSelected);
        job.isFrozenAfterDmsTransfer = ValueUpdater.updateNonNullableBoolean(job.isFrozenAfterDmsTransfer, sourceJob.isFrozenAfterDmsTransfer || false);
        return job;
    }
    constructor(externalId, title) {
        this.externalId = externalId;
        this.title = title;
        this.isActive = false;
        this.comment = '';
        this.customerStatement = '';
        this.defects = [];
        this.demandCategory = '';
        this.demandId = '';
        this.flatRateUnits = [];
        this.isSelected = false;
        this.packages = [];
        this.parts = [];
        this.positionNumber = null;
        this.lastModifiedVersion = 1;
        this.isFrozenAfterDmsTransfer = false;
    }
    getIsActive() {
        return this.isActive;
    }
    setIsActive(isActive) {
        this.isActive = isActive;
    }
    getExternalId() {
        return this.externalId;
    }
    setExternalId(externalId) {
        this.externalId = externalId;
    }
    getDemandCategory() {
        return this.demandCategory;
    }
    setDemandCategory(demandCategory) {
        this.demandCategory = demandCategory;
    }
    getDemandId() {
        return this.demandId;
    }
    setDemandId(demandId) {
        this.demandId = demandId;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getLastModifiedVersion() {
        return this.lastModifiedVersion;
    }
    setLastModifiedVersion(lastModifiedVersion) {
        this.lastModifiedVersion = lastModifiedVersion;
    }
    getTitle() {
        return this.title;
    }
    setTitle(title) {
        this.title = title;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getCustomerStatement() {
        return this.customerStatement;
    }
    setCustomerStatement(customerStatement) {
        this.customerStatement = customerStatement;
    }
    getDefects() {
        return this.defects;
    }
    setDefects(defects) {
        this.defects = defects;
    }
    getFlatRateUnits() {
        return this.flatRateUnits;
    }
    setFlatRateUnits(flatRateUnits) {
        this.flatRateUnits = flatRateUnits;
    }
    getPackages() {
        return this.packages;
    }
    setPackages(packages) {
        this.packages = packages;
    }
    getParts() {
        return this.parts;
    }
    setParts(parts) {
        this.parts = parts;
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsSelected(isSelected) {
        this.isSelected = isSelected;
    }
    getIsFrozenAfterDmsTransfer() {
        return this.isFrozenAfterDmsTransfer;
    }
    setIsFrozenAfterDmsTransfer(isFrozenAfterDmsTransfer) {
        this.isFrozenAfterDmsTransfer = isFrozenAfterDmsTransfer;
    }
}
//# sourceMappingURL=job.js.map